'use client';

import Link from "next/link";
import SponsoredBanners from "../ui/SponsoredBanners";
import BrandsList from "../ui/BrandsList";

export default function PopularBrandsSection() {
  return (
    <section className="" aria-label="Popular Cannabis Brands">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:mb-8 mb-4 flex flex-col md:flex-row md:items-start md:justify-between sm:gap-4 gap-3">
          <div className="flex-1">
            <h2 className="text-3xl sm:text-4xl font-bold text-text-primary">
              Popular mail order marijuana brands
            </h2>
          </div>
          <div className="md:text-right md:max-w-xl">
            <p className="text-base text-text-secondary leading-relaxed">
              Dank represents the most trusted Canadian cannabis brands. Each product is licensed, lab-tested, and Health
              Canada-approved.
            </p>
          </div>
        </div>
        <BrandsList />
        <div className="mt-8">
          <SponsoredBanners className="w-full" position="1" />
        </div>
      </div>
    </section>
  );
}

